import React, {useState, useContext, useEffect, useMemo, useRef} from 'react';
import { makeStyles } from '@material-ui/core/styles';

import TextField from '@material-ui/core/TextField';
import NativeSelect from '@material-ui/core/NativeSelect';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Paper, Typography } from '@material-ui/core';
import { LoadingButton } from '@mui/lab';

import {SearchPeriod} from '../../../model/constants'
import { getUSFullDate, parseLocalString } from '../../../utilities/utils'

import SystemTable from '../../tables/historyTables/SystemTable'
import OrganAutoTable from '../../tables/historyTables/OrganAutoTable'
import GeneratorTable from '../../tables/historyTables/GeneratorTable'
import StudiesTable from '../../tables/historyTables/StudiesTable'
import SofwareTable from '../../tables/historyTables/SofwareTable'
import DetectorTable from '../../tables/historyTables/DetectorTable'
import StandTable from '../../tables/historyTables/StandTable'
import DicomTable from '../../tables/historyTables/DicomTable'
import CommonTimeLine from '../../timelines/CommonTimeLine'

import * as EquipWorker from '../../../workers/equipWorker'
import { CurrentEquipContext } from '../../../context/currentEquip-context';
import { EventsContext } from '../../../context/events-context';
import { UsersContext } from '../../../context/users-context';
import { useExcelDownloder } from "react-xls";
import { set } from 'date-fns';

const useStyles = makeStyles((theme) => ({
	root: {
		height: "calc(100vh - 64px - 48px)",
		display: "flex",
		flexDirection: "row",
		gap: 10,
	},
	searchAndFiltration: {
		display: "flex",
		flexDirection: "column",
		flex: "0 0 300px",
		gap: 10,
	},
	events: {
		display: "flex",
		flexDirection: "row",
		flex: "1",
		gap: 10,
	},
	search: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "space-between",
		padding: "10px",
		height: "250px",
	},
	filtration: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "space-between",
		padding: "10px",
		height: "250px",
	},
	commonSpacing: {
		marginLeft: theme.spacing(1),
		marginRight: theme.spacing(1),
	},
	textField: {
		width: 200,
	},
	selectEmpty: {
		marginTop: theme.spacing(2),
	},
	pageSelector: {
		margin: "0 5px",
	},
	important: {
		display: "flex",
		justifyContent: "flex-start",
		padding: "10px",
  },
  download: {
    padding: "10px",
    marginTop: "auto",
    display: "flex",
    flexDirection: "column",
    gap: 10
	},
	downloadButton: {
		textDecoration: "none"
	},
	hidden: {
		width: 0,
		height: 0,
		display: "none"
	}
}));
const getTodayDate = () => new Date().toISOString().split("T")[0];

export default function SummaryHistoryTabPanel(props) {
	console.log("render SummaryHistoryTabPanel");

	const classes = useStyles();
	const [eventsState, eventsDispatch] = useContext(EventsContext);
	const [usersState, usersDispatch] = useContext(UsersContext);
	const [startDate, setStartDate] = useState(getTodayDate());
	const [endDate, setEndDate] = useState(getTodayDate()); 
	const [displayingStartDate, setDisplayingStartDate] = useState(getTodayDate());
	const [displayingEndDate, setDisplayingEndDate] = useState(getTodayDate());
	const [loading, setLoading] = useState(false);
	const [caseSensitive, setCaseSensitive] = useState(false);
	const [importantOnly, setImportantOnly] = useState(false);
	const [download, setDownload] = useState(false);
	const [filters, setFilters] = useState({
		byTitle: "",
		byDescr: "",
	});
	const { ExcelDownloder, Type, setData } = useExcelDownloder();

	const handleStartDateChange = (ev) => {
		setStartDate(ev.target.value);
	};

	const handleEndDateChange = (ev) => {
		setEndDate(ev.target.value);
	};

	const equipName = props.equipName;
	let events = eventsState.currentEvents;
	const token = usersState.token;

	const onSearch = async () => {
		//Set the load state to immediately display the load state on the search button
		setLoading(true);
		await EquipWorker.SearchEquip(token, "Events", equipName, startDate, endDate).then((allEvents) => {
			eventsDispatch({ type: "SETEVENTS", payload: allEvents });
			setLoading(false);
		});
		setDisplayingStartDate(startDate);
		setDisplayingEndDate(endDate);
	};

	const onSelect = async (event) => {
		setImportantOnly(!importantOnly);
	};

	if (filters.byTitle) {
		events = events?.filter(
			(p) =>
				(caseSensitive ? p.Title : p.Title.toLowerCase()).includes(
					caseSensitive ? filters.byTitle : filters.byTitle.toLowerCase()
				) ||
				(caseSensitive ? p.Description : p.Description.toLowerCase()).includes(
					caseSensitive ? filters.byTitle : filters.byTitle.toLowerCase()
				)
		);
	}

	if (filters.byDescr) {
		events = events?.filter((p) => p.Details?.includes(filters.byDescr));
	}
	if (importantOnly) {
		events = events?.filter((p) => p.Type?.includes("Error"));
	}

	const onTitleFilterChange = async (val) => {
		setFilters({ ...filters, ...{ byTitle: val.target?.value } });
	};

	const onDescrFilterChange = async (val) => {
		setFilters({ ...filters, ...{ byDescr: val.target?.value } });
	};

	const onCaseSensitive = () => setCaseSensitive((prev) => !prev);

	let data ={
		events: events.map((e) => {
			let config = e.EquipName.split("/")[0];
			let [serialNumber, UID] = e.EquipName.split("/")[1].split("_");
			let [date, time] = parseLocalString(e.DateTime).split(",");
			return {
				["Конфигурация"]: config,
				["Серийный номер"]: serialNumber,
				["UID"]: UID,
				["Дата"]: date,
				["Время"]: time,
				["Краткое описание"]: `${e.Title} - ${e.Description}`,
				["Детали"]: e.Details,
			};
		}),
	};



	const downloadButton = useMemo(
		() => {
			return <ExcelDownloder
				data={{...data}}
				filename={(() => `JournalEvents_${parseLocalString(Date.now())}`)()}
				type={Type.Link} // or type={'link'}
			>
				<Button
					variant="contained"
					color="primary"
					className={classes.commonSpacing}
				>
					Выгрузить события в файл
				</Button>
			</ExcelDownloder>
		},
		[eventsState.currentEvents]
	);

	return (
		<div className={classes.root}>
			<div className={classes.searchAndFiltration}>
				<Paper className={classes.search}>
					<Typography>Поиск за период</Typography>
					<TextField
						id="startDate"
						label="Начальная дата"
						type="date"
						defaultValue={startDate}
						onChange={handleStartDateChange}
						className={(classes.textField, classes.commonSpacing)}
						InputLabelProps={{
							shrink: true,
						}}
					/>
					<TextField
						id="endDate"
						label="Конечная дата"
						type="date"
						defaultValue={endDate}
						onChange={handleEndDateChange}
						className={(classes.textField, classes.commonSpacing)}
						InputLabelProps={{
							shrink: true,
						}}
					/>
					{
						<LoadingButton
							variant="contained"
							color="primary"
							className={classes.commonSpacing}
							onClick={onSearch}
							loading={loading}
							disabled={!(startDate && endDate)}>
							Искать
						</LoadingButton>
					}
				</Paper>
				<Paper className={classes.filtration}>
					<Typography>Фильтрация</Typography>
					<TextField
						id="outlined-basic"
						className={classes.commonSpacing}
						onChange={onTitleFilterChange}
						label="По названию"
						variant="outlined"
					/>
					<TextField
						id="outlined-basic"
						className={classes.commonSpacing}
						onChange={onDescrFilterChange}
						label="По описанию"
						variant="outlined"
					/>
					<FormControlLabel
						// className={classes.commonSpacing}
						control={
							<Checkbox checked={caseSensitive} onChange={onCaseSensitive} />
						}
						label="Учитывать регистр"
					/>
				</Paper>
				<Paper className={classes.important}>
					<FormControlLabel
						// className={classes.commonSpacing}
						control={<Checkbox checked={importantOnly} onChange={onSelect} />}
						label="Только важные"
					/>
				</Paper>
				<Paper className={classes.download}>
					<LoadingButton
						onClick={() => setDownload((prev) => !prev)}
						loading={download}
						variant="contained"
						color="primary"
						className={classes.commonSpacing}
						disabled={events.length > 70000}>
						Скачать файл событий
					</LoadingButton>
					{events.length > 70000 ? (
						<>
							<div>Лимит выгрузки превышен</div>
							<div>Для выгрузки доступно не более 70000 записей</div>
						</>
					) : (
						<></>
					)}
					{download ? (
						<>
							<ExcelDownloder
								className="excelDownloadLink"
								data={data}
								filename={(() =>
									`JournalEvents_${parseLocalString(Date.now())}`)()}
								type={Type.Link} // or type={'link'}
							>
								<div>Идет формирование файла...</div>
								<div>Пожалуйста, подождите</div>
							</ExcelDownloder>
							<script>
								{setTimeout(() => {
									let link =
										document.getElementsByClassName("excelDownloadLink")[0];
									if (link) {
										link.click()
									}
									setDownload(false);
								}, 1000)}
							</script>
						</>
					) : (
						<></>
					)}
				</Paper>
			</div>
			<div className={classes.events}>
				<CommonTimeLine
					equipName={equipName}
					rows={events}
					showImportantOnly={importantOnly}
					startDate={displayingStartDate}
					endDate={displayingEndDate}
				>
					</CommonTimeLine>
			</div>
		</div>
	);
}